import { useEffect, useRef, useState, useCallback } from "react"
import { getComputedColorValues } from "source/shared/colors"
import { useLayoutTheme } from "source/Layout"

export function useComputedColors() {
  const theme = useLayoutTheme()
  const [colors, setColors] = useState(() => getComputedColorValues())
  const animationFrameRef = useRef<number | null>(null)

  const recompute = useCallback(() => {
    setColors(getComputedColorValues())
  }, [])

  useEffect(() => {
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current)
    }
    // wait a frame for HTML attributes and CSS custom properties
    animationFrameRef.current = requestAnimationFrame(() => {
      recompute()
    })

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current)
      }
    }
  }, [theme, recompute])

  return { colors }
}
